module.exports = __webpack_public_path__ + "static/media/hair (3).629d2434.jpg";